module.exports = __webpack_public_path__ + "static/assets/ef18420234519a462792481f266247c7.svg";